<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <formly-form [fields]="fields" [form]="form" [(model)]="model"></formly-form>
  <div style="display: grid; grid-gap: 15px; grid-template-columns: repeat(2, 1fr);margin-top: 20px;">

    <button eBtn color="highlight" type="button" (click)="cancel.emit()">
      Annuleren
    </button>
    <button eBtn [disabled]="!canSubmit" type="submit"  color="primary">Opslaan</button>
  </div>
</form>
